// The Logistics page's URL vocabulary that OTHER pages need to deep-link into
// it. The page owns the rest of its params; these are shared because the
// scheduler's Stock tab sends the user to a specific delivery, and the
// assistant to a delivery or a material.

/** `?delivery=<ref>` opens that delivery's detail drawer on the Logistics page. */
export const DELIVERY_DETAIL_PARAM = 'delivery';

/** `?stock=<materialName>` opens that material's stock drawer — the material
 *  name IS the record's identity (the inventory API has no separate id). The
 *  assistant links a stock row here (`stock` in the shared navigation catalog). */
export const STOCK_DETAIL_PARAM = 'stock';

/** `?highlight=<ref>` scrolls the Delivery Pipeline to that card and flashes
 *  it — the board's own "jump to" gesture, without opening any drawer. The
 *  param STAYS in the URL: it is the deep link itself, so a reload lands on
 *  the same card. The page fires the jump once per distinct ref (a
 *  previous-value check, not an effect), which is what stops it re-flashing
 *  on every render. */
export const DELIVERY_HIGHLIGHT_PARAM = 'highlight';

/** The Logistics page URL with one delivery's detail drawer open. */
export function logisticsDeliveryPath(siteId: string, deliveryRef: string): string {
  return `/logistics/${encodeURIComponent(siteId)}?${DELIVERY_DETAIL_PARAM}=${encodeURIComponent(deliveryRef)}`;
}

/** The Logistics page URL that merely highlights one delivery's card. What a
 *  link from ANOTHER page uses: the reader is being shown where the order
 *  lives, not asked to edit it. */
export function logisticsDeliveryHighlightPath(siteId: string, deliveryRef: string): string {
  return `/logistics/${encodeURIComponent(siteId)}?${DELIVERY_HIGHLIGHT_PARAM}=${encodeURIComponent(deliveryRef)}`;
}
